import clsx from 'clsx';
import { formatDateTime } from '../utils';

const formatTechName = (technician) => {
  if (!technician) return 'Technician';
  return [technician.firstName, technician.lastName].filter(Boolean).join(' ').trim() || 'Technician';
};

export default function MessageThreadList({
  threads = [],
  selectedTechnicianId = null,
  onSelect,
  emptyMessage = 'No conversations yet. Message a technician from the Tech Dock.',
}) {
  if (threads.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center px-6 text-center text-sm text-gray-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto min-h-0">
      {threads.map((thread) => {
        const isSelected = selectedTechnicianId === thread.technicianId;
        const preview = thread.lastMessagePreview || 'No messages yet';
        const timestamp = thread.lastMessageAt ? formatDateTime(thread.lastMessageAt) : '';

        return (
          <button
            key={thread.id}
            type="button"
            onClick={() => onSelect(thread)}
            className={clsx(
              'w-full text-left px-4 py-3 border-b border-slate-200 transition-colors',
              isSelected ? 'bg-primary-50' : 'hover:bg-slate-50'
            )}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-gray-900 truncate">
                    {formatTechName(thread.technician)}
                  </span>
                  {thread.unreadCount > 0 && (
                    <span className="inline-flex min-w-[1.125rem] h-[1.125rem] px-1 rounded-full bg-primary-600 text-white text-2xs font-semibold items-center justify-center">
                      {thread.unreadCount}
                    </span>
                  )}
                </div>
                <p className="mt-0.5 text-xs text-gray-600 truncate">{preview}</p>
              </div>
              {timestamp && (
                <span className="flex-shrink-0 text-2xs text-gray-400 whitespace-nowrap">{timestamp}</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
